import { Grid } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { VisitDetails } from './VisitDetails'
import { VisitTimings } from './VisitTimings'

type Props = {
  visitId: number
  minutesLeft: number
}

export const VesselVisitKPIOverview: FC<Props> = observer(({ visitId, minutesLeft }: Props) => {
  const theme = useMinimalsTheme()
  const { vesselVisitItemStore } = usePlanningStore()

  useAsyncFetch(async () => {
    await vesselVisitItemStore.fetchById(visitId)
  }, [vesselVisitItemStore, visitId])

  const vesselVisitItem = computed(() => vesselVisitItemStore.elements[visitId]).get()

  const vesselVisitNumber = vesselVisitItem?.data.number
  const vesselName = vesselVisitItem?.vessels?.[0]?.data?.name
  const operator = vesselVisitItem?.operator?.data?.name
  const agent = vesselVisitItem?.shippingAgent?.data?.name
  const vesselService = `${vesselVisitItem?.data?.vesselServiceName}/${vesselVisitItem?.data?.vesselServiceServiceId}`
  const voyageNumber = vesselVisitItem?.voyages?.map(voyage => {
    const voyageNumber = `${voyage.inboundNumber}, ${voyage.outboundNumber}`
    const voyageShippingLine = voyage.shippingLine?.shortName

    if (voyageShippingLine) {
      return `${voyageNumber} (${voyageShippingLine})`
    }

    return voyageNumber
  })

  return (
    <Grid container size={12} spacing={theme.customSpacing.m}>
      <Grid size={4}>
        <VisitDetails
          vesselName={vesselName}
          vesselVisitNumber={vesselVisitNumber}
          voyageNumber={voyageNumber}
          operator={operator}
          agent={agent}
          vesselService={vesselService}
        />
      </Grid>
      <Grid size={8}>
        <VisitTimings vesselVisitItem={vesselVisitItem} minutesLeft={minutesLeft} />
      </Grid>
    </Grid>
  )
})
